// @flow
import { type ActionType, handleActions } from 'redux-actions';
import { Observation } from 'models';
import { Record, OrderedMap } from 'immutable';
import {
  requestAppConfig,
  receiveAppConfig,
  signalAppReady,
  signalAppNotReady,
} from './appConfigActions';

type AppConfigRecordShape = {
  observationsMap: OrderedMap<string, Observation>,
  observationCodeByClientIdMap: OrderedMap<string, Array<string>>,
  requestStatus: ?RequestStatus,
  sagaReady: boolean,
};
const defaultAppConfigRecordShape: AppConfigRecordShape = {
  observationsMap: new OrderedMap(),
  observationCodeByClientIdMap: new OrderedMap(),
  requestStatus: null,
  sagaReady: false,
};

export class AppConfigState extends Record(defaultAppConfigRecordShape) {}
const defaultAppConfigState = new AppConfigState();

export default handleActions(
  {
    [signalAppReady.toString()]: (
      state: AppConfigState,
      action: ActionType<typeof signalAppReady>
    ) => state.set('sagaReady', true),

    [signalAppNotReady.toString()]: (
      state: AppConfigState,
      action: ActionType<typeof signalAppReady>
    ) => state.set('sagaReady', false),

    [requestAppConfig.toString()]: (
      state: AppConfigState,
      action: ActionType<typeof requestAppConfig>
    ) => state.set('requestStatus', 'pending'),

    [receiveAppConfig.toString()]: {
      next(state: AppConfigState, action: ActionType<typeof receiveAppConfig>) {
        const observationsMap = flattenAppConfigResponseToObservationMap(
          action.payload
        );
        const observationCodeByClientIdMap = createObservationCodeByClientIdMap(
          action.payload
        );

        return state.merge({
          requestStatus: 'complete',
          observationsMap: observationsMap,
          observationCodeByClientIdMap: observationCodeByClientIdMap,
        });
      },
      throw(
        state: AppConfigState,
        action: ActionType<typeof receiveAppConfig>
      ) {
        return state.set('requestStatus', action.payload);
      },
    },
  },
  defaultAppConfigState
);

export const createObservationCodeByClientIdMap = (
  response: GetAppConfigResponseBody
) => {
  const newObservationsArray = [];
  // $FlowFixMe
  Object.keys(response).forEach((keyAsClientId: Id) => {
    const observationGroup = response[keyAsClientId];

    const clientObservationCodeList = [];

    observationGroup.map(({ observation_type_code, name }) => {
      return clientObservationCodeList.push(observation_type_code);
    });

    return newObservationsArray.push([
      keyAsClientId,
      clientObservationCodeList,
    ]);
  });

  return OrderedMap(newObservationsArray);
};

export const flattenAppConfigResponseToObservationMap = (
  response: GetAppConfigResponseBody
) => {
  const { global, ...custom } = response;

  const mapObervationTypeToMapEntry = (
    observation: ObservationTypeBlob
  ): [string, Observation] => {
    const observationCode = observation.observation_type_code;
    const observationType = Observation.createWithData(observation);

    return [observationCode, observationType];
  };

  const sortedGlobalObservationTypeEntries = global
    .sort(Observation.comparator)
    .map(mapObervationTypeToMapEntry);

  const allObservationTypeEntries = [...sortedGlobalObservationTypeEntries];

  Object.keys(custom).forEach(keyAsClientId => {
    const customObservationTypesForClientId = custom[keyAsClientId];

    customObservationTypesForClientId.forEach(t => {
      const entry = mapObervationTypeToMapEntry(t);
      allObservationTypeEntries.push(entry);
    });
  });

  return OrderedMap(allObservationTypeEntries);
};



// WEBPACK FOOTER //
// ./src/ducks/appConfigReducer.js